// src/screens/AdminDisputesScreen.js
// ============================================================================
// ADMIN DISPUTES SCREEN - route shell for DisputeAdminPanel
//
// The panel component existed but was never mounted anywhere; this screen
// gives it a URL (critcash.com/admin/disputes) so the AI dispute-brief email
// can deep-link straight to it. Auth: the callables it uses (getPendingDisputes,
// resolveDispute) are admin-gated server-side, so a non-admin who lands here
// just sees the load fail.
// ============================================================================

import React from 'react';
import { View, StyleSheet } from 'react-native';
import DisputeAdminPanel from '../components/DisputeAdminPanel';

export default function AdminDisputesScreen({ navigation }) {
  const handleClose = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate('AdminDashboard');
    }
  };

  return (
    <View style={styles.container}>
      <DisputeAdminPanel onClose={handleClose} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0b0b0b',
  },
});
